import { VectorPath } from '@aninix-inc/model/legacy'

type Payload = {
  data: VectorPath[]
}

export function getFillShape({ data }: Payload): VectorPath[] {
  return data
}
